import React, { ReactNode, useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  Typography,
  useTheme
} from "@material-ui/core";
import { isOk } from "../../../result";
import useStyles from "../styles";
import { ArrowDownward, ArrowUpward, BarChart } from "@material-ui/icons";
import { getUserStatusCount } from "../../../api/users";
import { UserStatusCount } from "../../../models/User";

interface Props {
  title: string;
  status: string;
}

export const UserStatusCounter = ({ title, status }: Props) => {
  const styles = useStyles();
  const theme = useTheme();

  const [state, setState] = useState({} as UserStatusCount);

  useEffect(() => {
    getUserStatusCount(status).then(result => {
      if (isOk(result)) {
        setState(result.value as UserStatusCount);
      }
    });
  }, []);

  return (
    <Card style={{ height: "100%", position: "relative" }}>
      {state?.total ? (
        <></>
      ) : (
        <div className={styles.spinnerContainer}>
          <CircularProgress />
        </div>
      )}
      <CardContent>
        <Box sx={{ display: "flex" }} pb={0}>
          <Box flexGrow={1}>
            <div>
              <Typography
                variant={"caption"}
                color={"textSecondary"}
                style={{ textTransform: "uppercase" }}
              >
                {title}
              </Typography>
            </div>
            <Typography variant={"h6"}>
              {state.total}
              <Typography
                color="textSecondary"
                variant="caption"
                style={{ marginLeft: 20 }}
              >
                Last 24h: {state.last24}
              </Typography>
            </Typography>
            <Box
              sx={{
                pt: 2,
                display: "flex",
                alignItems: "center"
              }}
            >
              {state.last24 > state.last24before ? (
                <ArrowDownward className={styles.error} />
              ) : (
                <ArrowUpward className={styles.success} />
              )}
              <Typography
                style={{
                  marginRight: 2,
                  color: `${
                    state.last24 > state.last24before
                      ? theme.palette.error.main
                      : theme.palette.success.main
                  }`
                }}
                variant="body2"
              >
                {state.last24 > state.last24before
                  ? state.last24 - state.last24before
                  : state.last24before - state.last24}
              </Typography>
              <Typography
                style={{ marginLeft: 3 }}
                color="textSecondary"
                variant="caption"
              >
                {state.last24 > state.last24before ? " More" : "Less"} than the
                previous 24h
              </Typography>
            </Box>
          </Box>
          <div>
            <BarChart className={styles.sectionIconPrimary} />
          </div>
        </Box>
      </CardContent>
    </Card>
  );
};
